module.exports = __webpack_public_path__ + "static/img/service_content3-3_icon.a903213.png";